<template>
<div class="chapter">
<div class="inner_page">
<div class="ch1" id="ch1-5">
<p class="centerImage"><img alt="images" id="img17" src="images/img17.jpg"/></p>
<p class="caption"><span class="bolditalic">Plan of the Battle of Plataea.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_ch15.vue?fb106c5a